'use strict';

require('./app/app');
// require('./jquery_app/app');
require('./templates/main');

